// extracted by css-extract-rspack-plugin
export default {"fieldDescription":"EVujF5VsQMInJHJD"};